module.exports = __webpack_public_path__ + "static/kotwica-252752fab68dfab6f406239c9abc4ccc.png";